(function () {
  let giftThreshold = 0;
   let isRemovingGifts = false;

  function getGiftSection() {
    let section = document.querySelector('[data-gift-section]');
    if (section) {
      let raw = section.dataset.giftThreshold || '0';
      let parsed = parseInt(raw, 10);
      giftThreshold = isNaN(parsed) ? 0 : parsed;
    } else {
    }
    return section;
  }

  // Collect all possible gift variant IDs (from gift bar radios + line dropdowns)
  function getGiftVariantIds() {
    let ids = [];

    let section = getGiftSection();
    if (section) {
      let radioInputs = section.querySelectorAll('[data-gift-option]');
      Array.prototype.forEach.call(radioInputs, function (input) {
        let id = Number(input.value);
        if (!isNaN(id) && ids.indexOf(id) === -1) {
          ids.push(id);
        }
      });
    }

    let selects = document.querySelectorAll('[data-gift-line-select]');
    Array.prototype.forEach.call(selects, function (select) {
      Array.prototype.forEach.call(select.options, function (opt) {
        let id = Number(opt.value);
        if (!isNaN(id) && ids.indexOf(id) === -1) {
          ids.push(id);
        }
      });
    });

    return ids;
  }

/* ================= SHIPPING BAR ================= */
function updateShippingBar(cart) {
  let bar = document.getElementById('shipping-bar');
  if (!bar || !cart) return;

  let currencySymbol    = bar.dataset.currencySymbol || '€'; // fallback
  let freeShippingCents = Number(bar.dataset.freeShipping || '0');
  let giftCents         = Number(bar.dataset.giftThreshold || giftThreshold || '0');
  let subtotal          = cart.total_price || 0;

  // If no free-shipping limit is set (0), fall back to gift threshold
  if (!freeShippingCents && giftCents) {
    freeShippingCents = giftCents;
  }

  bar.style.display = 'block';

  /* --- HEADLINE TEXT (only 2 messages) --- */
  let txt = bar.querySelector('[data-shipping-amount]');
  if (txt) {
    txt.textContent = '';

    if (giftCents > 0) {
      if (subtotal >= giftCents) {
        // Gift threshold reached
        txt.textContent = 'Congratulations! You are eligible for FREE shipping!';
      } else if (
        freeShippingCents > 0 &&
        subtotal >= freeShippingCents &&
        subtotal < giftCents
      ) {
        // Free shipping reached, gift not yet
        let remainingGift = ((giftCents - subtotal) / 100)
          .toFixed(2)
          .replace('.', ',');
        txt.textContent =
          'Spend another ' + currencySymbol + remainingGift + ' for an extra gift!';
      }
    }
  }

  /* --- slider fill --- */
  let fill = bar.querySelector('[data-shipping-fill]');
  let F = freeShippingCents;
  let G = giftCents || F;
  let S = subtotal;

  if (fill && (F > 0 || G > 0)) {
    let pct = 0;

    if (F <= 0 && G > 0) {
      pct = Math.min(100, (S / G) * 100);
    } else if (G <= F) {
      pct = Math.min(100, (S / F) * 100);
    } else {
      if (S <= F) {
        pct = (S / F) * 65;
      } else if (S < G) {
        let extraRatio = (S - F) / (G - F);
        pct = 65 + extraRatio * 35;
      } else {
        pct = 100;
      }
    }

    fill.style.width = pct + '%';
  }

  // States
  let hasGift = G > 0 && S >= G;
  let hasFree = (F > 0 && S >= F) || hasGift; // once you have gift, shipping is definitely active

  bar.classList.toggle('cart-progress--reach-shipping', hasFree);
  bar.classList.toggle('cart-progress--reach-gift', hasGift);

  let badgeEl = bar.querySelector('[data-shipping-badge]');
  if (badgeEl) {
    badgeEl.textContent = hasFree ? 'Active' : 'Not Active';
    badgeEl.classList.toggle('cart-progress__badge--active', hasFree);
  }

  let shippingRow = bar.querySelector('.cart-progress__row--shipping');
  if (shippingRow) {
    shippingRow.classList.toggle('cart-progress__row--active', hasFree);
  }
}


  function toggleUpsellVisibility(isGiftUnlocked) {
    let upsell = document.querySelector('[data-cart-upsell]');
    if (!upsell) return;

    // true = hide recommended products when gift is unlocked
  }


  /* =========== GIFT LINE TITLE/IMAGE HELPER =========== */
  function updateGiftLineDisplay(selectEl) {
    if (!selectEl) return;

    let opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return;

    let row = selectEl.closest('[data-cart-item]');
    if (!row) return;

    console.log('[GiftDebug] updateGiftLineDisplay -> option', {
      value: opt.value,
      title: opt.getAttribute && opt.getAttribute('data-title'),
      image: opt.getAttribute && opt.getAttribute('data-image')
    });

    // Prefer data-title if set, fall back to option text
    let newTitle = opt.getAttribute && opt.getAttribute('data-title');
    if (!newTitle && opt.textContent) {
      newTitle = opt.textContent.trim();
    }

    if (newTitle) {
      let titleLink = row.querySelector('.cart__items__title a');
      if (titleLink) {
        titleLink.textContent = newTitle;
      }
    }

    // Optional: change image if data-image is set on the <option>
    let newImage = opt.getAttribute && opt.getAttribute('data-image');
    if (newImage) {
      let img = row.querySelector('.cart__items__image img');
      if (img) {
        img.src = newImage;
      }
    }
  }

  /* ================= GIFT BAR ================= */
/* ================= GIFT BAR ================= */
function updateGiftUI(cart) {
  let section = getGiftSection();
  // If we get an error object (e.g. { error: '409 Conflict' }), bail out
  if (!section || !cart || !Array.isArray(cart.items)) {
    return;
  }

  let toggleBtn = section.querySelector('[data-gift-toggle]');
  let giftVariantIds = getGiftVariantIds();

  // Count NON-gift items (by quantity)
  let nonGiftCount = cart.items.reduce(function (sum, item) {
    let vid = Number(item.variant_id || item.id);
    let isGift = giftVariantIds.indexOf(vid) !== -1;
    return isGift ? sum : sum + item.quantity;
  }, 0);

  // Gift lines currently in cart
  let selectedInCart = cart.items.filter(function (item) {
    let vid = Number(item.variant_id || item.id);
    return giftVariantIds.indexOf(vid) !== -1;
  });

  let selectedCount = selectedInCart.reduce(function (sum, item) {
    return sum + item.quantity;
  }, 0);

  // ✅ Only unlock gift if at least 1 non-gift items
  let eligible = nonGiftCount >= 1;

  toggleUpsellVisibility(eligible);
  section.classList.toggle('gift-bar--locked', !eligible);
  section.classList.toggle('gift-bar--eligible', eligible);

  if (!eligible) {
    section.classList.remove('gift-bar--open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
  } else {
    if (selectedCount === 0 && !section.classList.contains('gift-bar--open')) {
      section.classList.add('gift-bar--open');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    }
  }

  let badge = section.querySelector('[data-gift-badge]');
  if (badge) {
    badge.textContent = eligible ? 'Active' : 'Not Active';
  }

  section.dataset.hasGift = selectedCount > 0 ? 'true' : 'false';

  let counter = section.querySelector('[data-gift-counter]');
  if (counter) {
    counter.textContent = selectedCount + '/1 Selected';
  }

  // If we found a gift in cart, get its variant id
  let selectedVariantId = selectedInCart.length
    ? Number(selectedInCart[0].variant_id || selectedInCart[0].id)
    : null;

  // Sync header radios & disable when not eligible
  let inputs = section.querySelectorAll('[data-gift-option]');
  Array.prototype.forEach.call(inputs, function (input) {
    input.checked = !!selectedVariantId && Number(input.value) === selectedVariantId;
    input.disabled = !eligible;
  });

  // Sync the dropdown(s) in the line items
  let selects = document.querySelectorAll('[data-gift-line-select]');
  Array.prototype.forEach.call(selects, function (select) {
    if (selectedVariantId) {
      console.log('[GiftDebug] syncing dropdown', {
        selectId: select.id,
        value: selectedVariantId
      });

      select.value = String(selectedVariantId);
      updateGiftLineDisplay(select);
    }
  });

  // Helper message now based on item count
  let helper = section.querySelector('[data-gift-helper]');
  if (helper) {
    if (!eligible) {
  helper.textContent = 'Add 1 item to your cart to unlock your free gift.';
} else if (selectedCount === 0) {
      helper.textContent = 'Please select one complimentary gift above.';
    } else {
      helper.textContent = 'Your complimentary gift has been added to your order.';
    }
  }

  // Auto-remove gifts if customer is no longer eligible
  if (!eligible && selectedInCart.length > 0 && giftVariantIds.length > 0) {
    removeGifts(giftVariantIds);
  }
}


  function applyCartState(cart) {
  if (!cart) return;
  console.log('[GiftDebug] applyCartState -> cart', cart);
  updateShippingBar(cart);
  updateGiftUI(cart);
   updateUpsellFirstCard(cart);
}

function updateUpsellFirstCard(cart) {
  try {
    const upsell = document.querySelector('[data-cart-upsell]');
    if (!upsell) return;

    const track = upsell.querySelector('[data-upsell-track]');
    if (!track) return;

    // find or create dynamic card
    let dynamicCard = track.querySelector('[data-upsell-card-dynamic]');
    if (!dynamicCard) {
      const firstStaticCard = track.querySelector('[data-upsell-card]');
      if (!firstStaticCard) return;

      dynamicCard = document.createElement('article');
      dynamicCard.className = 'cart-upsell__card';
      dynamicCard.setAttribute('data-upsell-card', '');
      dynamicCard.setAttribute('data-upsell-card-dynamic', 'true');

      track.insertBefore(dynamicCard, firstStaticCard);
    }

    const items = (cart && cart.items) || [];
    if (!items.length) {
      dynamicCard.innerHTML = '';
      return;
    }

    const recentItem = items[items.length - 1];
    if (!recentItem || !recentItem.handle) return;

    fetch('/products/' + recentItem.handle + '.js')
      .then((res) => {
        if (!res.ok) throw new Error('product.js fetch failed');
        return res.json();
      })
      .then((product) => {
        if (!product || !product.variants || !product.variants.length) return;

        dynamicCard.setAttribute('data-product-id', String(product.id));

        const variants        = product.variants;
        const selectedVariant = variants[1] || variants[0];

        const currentPriceCents = selectedVariant.price || 0;
        const comparePriceCents = selectedVariant.compare_at_price || 0;
        const currentPriceText  = (currentPriceCents / 100).toFixed(2);
        const comparePriceText  =
          comparePriceCents > currentPriceCents
            ? (comparePriceCents / 100).toFixed(2)
            : '';

        // image
        let baseImageSrc = '';
        if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
          baseImageSrc = selectedVariant.featured_image.src;
        } else if (product.images && product.images[0]) {
          baseImageSrc = product.images[0].src;
        }
        if (baseImageSrc) {
          baseImageSrc = baseImageSrc.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2');
        }

        // subtitle (first option name, skipping default)
        let subtitle = '';
        if (product.options && product.options.length) {
          const firstOpt = product.options[0];
          const optName =
            typeof firstOpt === 'string'
              ? firstOpt
              : (firstOpt && typeof firstOpt.name === 'string' ? firstOpt.name : '');
          if (
            optName &&
            optName.toLowerCase() !== 'title' &&
            optName.toLowerCase() !== 'default'
          ) {
            subtitle = optName;
          }
        }

        // title: try to use short title span from DOM
        let title = product.title || '';
        try {
          const shortNode = document.querySelector(
            '[data-product-short-title][data-product-id="' + product.id + '"]'
          );
          if (shortNode) {
            const shortTitle = shortNode.getAttribute('data-short-title');
            if (shortTitle && shortTitle.trim() !== '') {
              title = shortTitle.trim();
            }
          }
        } catch (e) {
          console.warn('[CartUpsell] could not read short title metafield', e);
        }

        const productUrl = '/products/' + product.handle;

        // build <option> list with price + compare + image
        const optionsHtml = variants
          .map((v) => {
            let vImg = '';
            if (v.featured_image && v.featured_image.src) {
              vImg = v.featured_image.src.replace(
                /(\.[a-zA-Z]+)(\?|$)/,
                '_160x$1$2'
              );
            } else if (baseImageSrc) {
              vImg = baseImageSrc;
            }

            const vPriceText = (v.price / 100).toFixed(2);
            const vCompareText =
              v.compare_at_price && v.compare_at_price > v.price
                ? (v.compare_at_price / 100).toFixed(2)
                : '';

            return (
              '<option value="' +
              v.id +
              '" ' +
              (Number(v.id) === Number(selectedVariant.id) ? 'selected' : '') +
              ' data-price="' +
              vPriceText +
              '" data-compare="' +
              vCompareText +
              '" data-image="' +
              vImg +
              '">' +
              v.title +
              '</option>'
            );
          })
          .join('');

        // card HTML with compare + current price spans
        const html =
          '<a href="' +
          productUrl +
          '" class="cart-upsell__image">' +
          (baseImageSrc
            ? '<img src="' +
              baseImageSrc +
              '" alt="' +
              title.replace(/"/g, '&quot;') +
              '">'
            : '') +
          '</a>' +
          '<div class="cart-upsell__content">' +
          '  <div class="cart-upsell__top">' +
          '    <div class="cart-upsell__info">' +
          '      <h4 class="cart-upsell__title-main">' +
          title +
          '</h4>' +
          (subtitle ? '<p class="cart-upsell__subtitle">' + subtitle + '</p>' : '') +
          '    </div>' +
          '    <p class="cart-upsell__price">' +
          '      <span class="cart-upsell__price-compare"' +
          (comparePriceText ? '' : ' style="display:none;"') +
          '>' +
          (comparePriceText || '') +
          '</span>' +
          '      <span class="cart-upsell__price-current">' +
          currentPriceText +
          '</span>' +
          '    </p>' +
          '  </div>' +
          '  <div class="cart-upsell__controls">' +
          '    <select class="cart-upsell__select" data-upsell-variant>' +
          optionsHtml +
          '    </select>' +
          '    <button type="button" class="cart-upsell__add" data-upsell-add>' +
          '      Add' +
          '    </button>' +
          '  </div>' +
          '</div>';

        dynamicCard.innerHTML = html;
      })
      .catch((err) => {
        console.error('[CartUpsell] updateUpsellFirstCard failed', err);
      });
  } catch (e) {
    console.error('[CartUpsell] updateUpsellFirstCard error', e);
  }
}

  function fetchCartAndApply() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js failed');
        return res.json();
      })
      .then(applyCartState)
      .catch(function (err) {
      });
  }

  function themeCartRefresh(cart, options) {
    let opts = options || {};
    let giftUpdate = !!opts.giftUpdate;

    try {
      document.dispatchEvent(new CustomEvent('theme:cart:change', {
        detail: { cart: cart, giftUpdate: giftUpdate },
        bubbles: true
      }));
    } catch (e) {}

    try {
      document.dispatchEvent(new CustomEvent('theme:cart:reload', {
        detail: { giftUpdate: giftUpdate },
        bubbles: true
      }));
    } catch (e) {}
  }

function removeGifts(variantIds) {
  if (!variantIds || !variantIds.length) return;

  // Prevent multiple simultaneous /cart/update calls
  if (isRemovingGifts) return;
  isRemovingGifts = true;

  let updates = {};
  variantIds.forEach(function (id) {
    updates[id] = 0;
  });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ updates: updates })
  })
    .then(function (res) {
      return res.json().then(function (data) {
        // If Shopify responds with an error (e.g. 409), log and stop
        if (!res.ok || data.error) {
          console.error('[GiftDebug] removeGifts failed', data);
          return null;
        }
        return data;
      });
    })
    .then(function (cart) {
      // Only apply state when we have a valid cart object
      if (!cart) return;
      applyCartState(cart);
      themeCartRefresh(cart, { giftUpdate: true });
    })
    .catch(function (err) {
      console.error('[GiftDebug] removeGifts fetch error', err);
    })
    .finally(function () {
      isRemovingGifts = false;
    });
}

  /* ===== Add / change gift without full page refresh ===== */
  function setGiftVariant(newVariantId, sourceSelect) {
    let section = getGiftSection();
    if (!section || !newVariantId) return;

    newVariantId = Number(newVariantId);
    if (!newVariantId) return;

    // All possible gift variant IDs from header radios + line dropdown(s)
    let giftVariantIds = getGiftVariantIds();

    let updates = {};

    // 1) Remove ALL existing gifts first
    if (giftVariantIds && giftVariantIds.length) {
      giftVariantIds.forEach(function (id) {
        updates[id] = 0; // clear each gift variant
      });
    }

    // 2) Add only the newly selected gift
    updates[newVariantId] = 1;


    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {

        // Update gift bar + shipping bar state
        applyCartState(cart);

        // Update the specific line visually (title/image) that triggered the change
        if (sourceSelect) {
          updateGiftLineDisplay(sourceSelect);
        }

        // Auto-close the gift dropdown area after selection
        let sec = getGiftSection();
        if (sec) {
          sec.classList.remove('gift-bar--open');
          let t = sec.querySelector('[data-gift-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }

        // Let the theme redraw the cart drawer
        themeCartRefresh(cart, { giftUpdate: true });
      })
      .catch(function (err) {
        console.error('[GiftDebug] Error updating gift', err);
      });
  }

  function attachGiftBarListeners() {
    let section = getGiftSection();
    if (!section) return;

    let toggleBtn = section.querySelector('[data-gift-toggle]');
    if (toggleBtn && !toggleBtn.__giftBound) {
      toggleBtn.__giftBound = true;
      toggleBtn.addEventListener('click', function () {
        if (toggleBtn.disabled) return;
        let isOpen = !section.classList.contains('gift-bar--open');
        section.classList.toggle('gift-bar--open', isOpen);
        toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    // Radios in the header gift bar
    if (!section.__giftRadioBound) {
      section.__giftRadioBound = true;
      section.addEventListener('change', function (event) {
        let input = event.target.closest('[data-gift-option]');
        if (!input || input.disabled) return;
        let selectedVariantId = Number(input.value);
        if (!selectedVariantId) return;
        setGiftVariant(selectedVariantId, null);
      });
    }
  }

  /* ===== Delegated dropdown listener for line item gifts ===== */
  function attachGiftLineDropdownDelegated() {
    if (document.__giftDelegated) return;
    document.__giftDelegated = true;

    document.addEventListener('change', function (event) {
      let select = event.target.closest('[data-gift-line-select]');
      if (!select) return;

      let newVariantId = Number(select.value);
      console.log('[GiftDebug] delegated dropdown change ->', {
        selectId: select.id,
        value: select.value,
        newVariantId: newVariantId
      });

      if (!newVariantId) return;
      setGiftVariant(newVariantId, select);
    });
  }

  /* ===== Auto-open drawer on normal cart changes (add to cart) ===== */
  function openDrawerIfNeeded(sourceDetail) {
    let detail = sourceDetail || {};
    if (detail.giftUpdate) {
      return; // don't auto open when we are just switching gift
    }

    let state = window.theme && window.theme.state;
    if (state && state.cartOpen) {
      return;
    }

    // Prefer an open trigger (header/cart icon), fallback to any toggle
    let trigger = document.querySelector('[data-drawer-toggle="drawer-cart"]:not(.drawer__close)');
    if (!trigger) {
      trigger = document.querySelector('[data-drawer-toggle="drawer-cart"]');
    }

    if (trigger) {
      trigger.click();
    } else {
    }
  }

  /* ================= INIT ================= */
  document.addEventListener('DOMContentLoaded', function () {
    console.log('[GiftDebug] DOMContentLoaded');
    fetchCartAndApply();
    attachGiftBarListeners();
    attachGiftLineDropdownDelegated();

    // ✅ Only auto-open drawer on PRODUCT page add-to-cart
    if (document.body.classList.contains('template-product')) {
      document.addEventListener('click', function (event) {
        let addBtn = event.target.closest('[data-add-to-cart], button[name="add"]');
        if (!addBtn) return;

        // Let the theme finish its AJAX / cart.js update first
        setTimeout(function () {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              applyCartState(cart);
            })
            .catch(function (err) {
            });
        }, 400);
      });
    }
  });

  document.addEventListener('theme:cart:change', function (event) {
    let detail = event.detail || {};
    if (detail.cart) {
      applyCartState(detail.cart);
    }
  });

  document.addEventListener('theme:cart:reload', function (event) {
    attachGiftBarListeners();
  });
})();


//////////////////////////////////////////////////////////
// UPSELL SLIDER: native swipe + arrows + compare-at + AJAX
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
// UPSELL SLIDER: swipe + arrows + compare-at + AJAX
//////////////////////////////////////////////////////////
function initCartUpsell() {
  const upsell = document.querySelector('[data-cart-upsell]');
  if (!upsell || upsell.__initialized) return;
  upsell.__initialized = true;

  const wrapper = upsell.querySelector('.cart-upsell__track-wrapper');
  const track   = upsell.querySelector('[data-upsell-track]');
  let   cards   = track ? Array.from(track.querySelectorAll('[data-upsell-card]')) : [];
  const prevBtn = upsell.querySelector('[data-upsell-prev]');
  const nextBtn = upsell.querySelector('[data-upsell-next]');
  const dotsWrap= upsell.querySelector('[data-upsell-dots]');

  if (!wrapper || !track) return;
  cards = track ? Array.from(track.querySelectorAll('[data-upsell-card]')) : [];
  if (!cards.length) {
    upsell.classList.add('cart-upsell--hidden');
    return;
  }

  // ---- ensure wrapper is horizontally scrollable ----
  wrapper.style.overflowX = 'auto';
  wrapper.style.overflowY = 'hidden';
  wrapper.style.scrollBehavior = 'smooth';
  wrapper.style.webkitOverflowScrolling = 'touch';
  // in case theme sets bad touch-action, we override with CSS too
  wrapper.classList.add('cart-upsell__track-wrapper--scrollable');

  // ---- scroll helpers ----
  let maxScroll = 0;
  function computeMaxScroll() {
    maxScroll = Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);
  }

  function updateButtons() {
    computeMaxScroll();
    const pos = wrapper.scrollLeft;
    if (prevBtn) prevBtn.disabled = pos <= 0;
    if (nextBtn) nextBtn.disabled = pos >= maxScroll - 1;
  }

  function scrollByStep(direction) {
    computeMaxScroll();
    const cardWidth = cards[0] ? cards[0].offsetWidth : wrapper.clientWidth;
    const step = cardWidth + 16; // 16px gap
    let target = wrapper.scrollLeft + direction * step;
    if (target < 0) target = 0;
    if (target > maxScroll) target = maxScroll;
    wrapper.scrollTo({ left: target, behavior: 'smooth' });
  }

  // ---- dots ----
  let currentIndex = 0;
  const dots = [];
  if (dotsWrap) {
    dotsWrap.innerHTML = '';
    cards.forEach((_, idx) => {
      const dot = document.createElement('span');
      dot.className = 'cart-upsell__dot' + (idx === 0 ? ' cart-upsell__dot--active' : '');
      dotsWrap.appendChild(dot);
      dots.push(dot);
    });
  }

  function updateDots() {
    dots.forEach((dot, idx) => {
      dot.classList.toggle('cart-upsell__dot--active', idx === currentIndex);
    });
  }

  // sync index when user scrolls (swipe, drag or arrows)
  wrapper.addEventListener('scroll', () => {
    const scrollLeft = wrapper.scrollLeft;
    let nearestIndex = 0;
    let nearestDist  = Infinity;
    const firstLeft  = cards[0].offsetLeft;

    cards.forEach((card, idx) => {
      const cardOffset = card.offsetLeft - firstLeft;
      const dist = Math.abs(cardOffset - scrollLeft);
      if (dist < nearestDist) {
        nearestDist  = dist;
        nearestIndex = idx;
      }
    });

    currentIndex = nearestIndex;
    updateDots();
    updateButtons();
  });

  // ---- manual drag / swipe (works even if theme messes with touch) ----
  let isDragging = false;
  let dragStartX = 0;
  let startScrollLeft = 0;

  function dragStart(e) {
    isDragging = true;
    dragStartX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    startScrollLeft = wrapper.scrollLeft;
  }

  function dragMove(e) {
    if (!isDragging) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const deltaX = clientX - dragStartX;
    wrapper.scrollLeft = startScrollLeft - deltaX;
  }

  function dragEnd() {
    isDragging = false;
  }

  wrapper.addEventListener('mousedown', dragStart);
  wrapper.addEventListener('mousemove', dragMove);
  wrapper.addEventListener('mouseup', dragEnd);
  wrapper.addEventListener('mouseleave', dragEnd);

  wrapper.addEventListener('touchstart', dragStart, { passive: true });
  wrapper.addEventListener('touchmove', dragMove, { passive: false });
  wrapper.addEventListener('touchend', dragEnd);
  wrapper.addEventListener('touchcancel', dragEnd);

  // initial state
  computeMaxScroll();
  updateButtons();
  updateDots();

  // arrows
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      scrollByStep(-1);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      scrollByStep(1);
    });
  }

  // ===== variant change -> price + compare + image =====
  track.addEventListener('change', (event) => {
    const select = event.target.closest('[data-upsell-variant]');
    if (!select) return;

    const card = select.closest('[data-upsell-card]');
    if (!card) return;

    const opt = select.options[select.selectedIndex];
    if (!opt) return;

    const priceText   = opt.getAttribute('data-price');
    const compareText = opt.getAttribute('data-compare');
    const imageUrl    = opt.getAttribute('data-image');

    const priceWrap  = card.querySelector('.cart-upsell__price');
    const currentEl  = priceWrap && priceWrap.querySelector('.cart-upsell__price-current');
    const compareEl  = priceWrap && priceWrap.querySelector('.cart-upsell__price-compare');

    if (currentEl && priceText) {
      currentEl.textContent = priceText;
    }

    if (compareEl) {
      if (compareText && compareText !== '' && compareText !== '0') {
        compareEl.textContent = compareText;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (imageUrl) {
      const imgEl = card.querySelector('.cart-upsell__image img');
      if (imgEl) imgEl.src = imageUrl;
    }
  });

  // ===== AJAX add to cart for upsell =====
  track.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-upsell-add]');
    if (!btn) return;
    if (btn.classList.contains('is-loading')) return;

    const card = btn.closest('[data-upsell-card]');
    if (!card) return;

    const variantEl = card.querySelector('[data-upsell-variant]');
    if (!variantEl) return;

    const variantId = Number(variantEl.value);
    if (!variantId) {
      console.warn('[CartUpsell] No valid variant id on upsell');
      return;
    }

    btn.classList.add('is-loading');
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = '‎ ';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) =>
        res
          .json()
          .then((data) => ({ ok: res.ok, data }))
          .catch(() => ({ ok: res.ok, data: null }))
      )
      .then((result) => {
        if (!result.ok) {
          console.error('[CartUpsell] add.js error', result.data);
          if (result.data && result.data.description) {
            alert(result.data.description);
          } else {
            alert('Could not add this product to the cart.');
          }
          throw new Error('Upsell add failed');
        }
        return fetch('/cart.js', { credentials: 'same-origin' });
      })
      .then((res) => res.json())
      .then((cart) => {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: { cart },
            bubbles: true,
          })
        );
        document.dispatchEvent(
          new CustomEvent('theme:cart:reload', {
            detail: {},
            bubbles: true,
          })
        );
      })
      .catch((err) => {
        console.error('[CartUpsell] Error adding upsell item', err);
      })
      .finally(() => {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });
}

document.addEventListener('DOMContentLoaded', initCartUpsell);
document.addEventListener('theme:cart:reload', initCartUpsell);

